// components/Loader.js
import React from "react";
import "./Loader.css";

const Loader = () => (
  <div className="loader-container">
    <div className="spinner-with-logo">
      <img src="/logo.png" alt="Logo" className="loader-logo" />
      <div className="spinner-ring" />
    </div>
  </div>
);

export default Loader;
